import React, { useEffect, useState } from 'react';
import Support from './Support';
import Landing from './Landing';
import landingStyles from './styles/landing.scss';
import FirebaseAnalytics from '../core/analytics';
import { useSelector } from 'react-redux';
import { RootState } from 'bootstrap';
import { useLanguageSelectionFeatureEnabled } from '../../hooks/useLanguageSelection';
import Language from '../language/Language';
import { getHasUserSetLanguage } from '../../i18n';
import CPUA4769Landing from './CPUA4769Landing';
import cpua4769landingStyles from './styles/cpua4769landing.scss';

export default function LandingPage({ setRerender }: {setRerender: React.Dispatch<React.SetStateAction<number>>}) {
  const [isSupport, setIsSupport] = useState(false);
  const [userPosition, setUserPosition] = useState({ lat: '0', lng: '0' });
  const clientIp = useSelector<RootState, string>((state) => state.app.clientIp);
  const isLanguageSelectionFeatureEnabled = useLanguageSelectionFeatureEnabled();
  const hasUserSetLanguage = getHasUserSetLanguage();
  const features = useSelector<RootState, string[]>((state) => state.app.features);
  const cpua4769Web = features.includes('CPUA-4769-WEB');

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setUserPosition({
        lat: position.coords.latitude.toString(),
        lng: position.coords.longitude.toString(),
      });
    });
  }, []);

  const sendAnalyticsEvent = (description) => {
    const params = {
      [FirebaseAnalytics.PARAMETERS.LAT]: userPosition.lat,
      [FirebaseAnalytics.PARAMETERS.LNG]: userPosition.lng,
      [FirebaseAnalytics.PARAMETERS.USER_IP]: clientIp,
      [FirebaseAnalytics.PARAMETERS.DESCRIPTION]: description,
    };
    FirebaseAnalytics.sendEvent(
      FirebaseAnalytics.EVENTS.CLICK,
      FirebaseAnalytics.MODULES.REGISTRATION,
      FirebaseAnalytics.PAGES.LANDING,
      params,
    );
  };

  const handleShowAsSupportPage = () => {
    !isSupport && sendAnalyticsEvent('contactUs');
    setIsSupport(!isSupport);
  };

  const landing = cpua4769Web ?
    (<CPUA4769Landing handleShowAsSupportPage={handleShowAsSupportPage}
      sendAnalyticsEvent={sendAnalyticsEvent}
      setRerender={setRerender}/>) :
    (<Landing
      handleShowAsSupportPage={handleShowAsSupportPage}
      sendAnalyticsEvent={sendAnalyticsEvent}
      setRerender={setRerender}/>);

  return (
    <div className={cpua4769Web && hasUserSetLanguage ? cpua4769landingStyles.container : landingStyles.container}>
      <div className={cpua4769Web && hasUserSetLanguage ? cpua4769landingStyles.landingWindow : landingStyles.landingWindow }>
        {isLanguageSelectionFeatureEnabled && !hasUserSetLanguage ? (
          <Language setRerender={setRerender} />
        ) : isSupport ? (
          <Support handleShowAsSupportPage={handleShowAsSupportPage} />
        ) : landing}
      </div>
    </div>
  );
}
